import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import _ from "lodash";
import ReactTooltip from 'react-tooltip';
import { connect } from "react-redux";
import { naver } from './side_menu_mapper'
import { getPermissions } from '../../actions/helper';
import { getUser } from '../../actions/session';
import { INVOICE_BASE, REPORTS_BASE_URL } from '../routers/RouteConstants';

var $ = window.$;

class SideMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            User: getUser(),
            nav_items: [],
            render_key: "__render__",
            fa_icon: "fa_icon",
            openMenus: {},
        }

        // for getting the current path
        this.checkCurrentURL = this.checkCurrentURL.bind(this);

        // for building side menu dictionary according to the user permission
        this.__build_render_dictionary = this.__build_render_dictionary.bind(this);

        // rendering side menu item from the dictionary
        this.__render = this.__render.bind(this);
        this.__render_single = this.__render_single.bind(this);
        this.__render_group = this.__render_group.bind(this);
        this.__render_dictionary = this.__render_dictionary.bind(this);

        // rendering user card on side menu
        this.__render_mobile_navigator = this.__render_mobile_navigator.bind(this);
        this.__render_user_card = this.__render_user_card.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    componentDidMount() {
        // Open the menu group matching the current URL on initial load
        var activation = this.checkCurrentURL();
        if (activation['whoIsOpen']) {
            this.setState({ openMenus: { [activation['whoIsOpen']]: true } });
        }
    }

    componentDidUpdate(prevProps) {
        // When route changes, ensure the active menu group is open
        if (this.props.location.pathname !== prevProps.location.pathname) {
            var activation = this.checkCurrentURL();
            if (activation['whoIsOpen'] && !this.state.openMenus[activation['whoIsOpen']]) {
                this.setState(function(prevState) {
                    var updated = Object.assign({}, prevState.openMenus);
                    updated[activation['whoIsOpen']] = true;
                    return { openMenus: updated };
                });
            }
        }
    }

    toggleMenu(menuName) {
        this.setState(function(prevState) {
            var updated = Object.assign({}, prevState.openMenus);
            updated[menuName] = !updated[menuName];
            return { openMenus: updated };
        });
    }

    getPermissions(serverPermissions) {
        var finalPermission = serverPermissions;
        return finalPermission;
    }

    checkCurrentURL() {
        var _location = this.props.location;
        var _path = _location.pathname.split('/');

        var activation = {}

        if (_path.length > 2) {
            activation['whoIsOpen'] = _path[1]
            activation['whoIsActive'] = '/' + _path[2]
        }
        else {
            activation['whoIsOpen'] = _path[1]
            activation['whoIsActive'] = '/' + _path[1]
        }

        return activation;
    }

    /**
     * Buidling Side Menu Struture Before rendering
     * ----------------------------------------------
     * defining structure
     *
     * gettting user permission
     *
     * getting the permissable side Menu Items
     *
     */
    __build_render_dictionary() {
        if (!_.isEmpty(this.props.activeUser)) {

            // rearranging permission according to the groups

            // building an empty init dictionary with render:False in all keys
            var final_renderer = {};
            var render_key = this.state.render_key;

            for (var key in naver) {
                final_renderer[key] = { [render_key]: false, [this.state.fa_icon]: naver[key]['fa_icon'] }
            }

            var serverPermissions = getPermissions(this.props.activeUser);
            var permission = this.getPermissions(serverPermissions);

            if (permission.length !== 0) {
                for (var i = 0; i < permission.length; i++) {
                    var elem = permission[i].split('/');
                    var parent = '/' + elem[1];
                    var getDetails = naver[parent];

                    // if that permission is renderable
                    if (getDetails) {
                        var getChildren = Object.keys(getDetails);
                        var count = getChildren.length;

                        if (count === 2) {
                            var temp = Object.keys(naver[parent]);
                            if (temp[0] !== "fa_icon") {
                                final_renderer[parent][temp[0]] = naver[parent][temp[0]]
                            }
                            else {
                                final_renderer[parent][temp[1]] = naver[parent][temp[1]]
                            }
                            final_renderer[parent][render_key] = true
                        }
                        else {
                            var child_name = "/";
                            if (elem[2])
                                child_name = '/' + elem[2];
                            var child_details = naver[parent][child_name]
                            // if that sub permission is renderable
                            if (child_details) {
                                final_renderer[parent][child_name] = child_details
                                final_renderer[parent][render_key] = true
                            }
                        }
                    }
                }

                if (final_renderer[INVOICE_BASE] && final_renderer[INVOICE_BASE][render_key]) {
                    var emailHistoryChild = naver[INVOICE_BASE]['/email-history'];

                    if (emailHistoryChild) {
                        final_renderer[INVOICE_BASE]['/email-history'] = emailHistoryChild;
                    }
                }

                if (final_renderer[REPORTS_BASE_URL] && final_renderer[REPORTS_BASE_URL][render_key]) {
                    var carrierMediaChild = naver[REPORTS_BASE_URL]['/carrier-media-stats'];

                    if (carrierMediaChild) {
                        final_renderer[REPORTS_BASE_URL]['/carrier-media-stats'] = carrierMediaChild;
                    }
                }

                return final_renderer;
            }
        }
    }

    /**
     *
     * Render Function only for Single Side Menu Item
     *
     * @param {any} object      containing side Menu renderring information
     * @param {string} _key     unique key of that item
     */
    __render(object, _key, whoIsOpen, whoIsActive, isGroup = false) {

        var active = whoIsActive;

        if (whoIsOpen && '/' + whoIsOpen !== whoIsActive) {
            active = '/' + whoIsOpen + whoIsActive;
            if (active.slice(-1) === '/') {
                active = active.slice(0, -1);
            }
        }
        let ItemText = "";
        let itemIcon = "";
        if (isGroup) {
            ItemText = object['name'];
        }
        else {
            itemIcon = <div style={{ width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} ><i className={`${object['fa_icon']} side-menu_icon`}> </i></div>;
            ItemText = <span className="ml-2" style={{fontSize: '13px'}}>{object['name']}</span>;
        }

        var isActive = (active === object['url']);
        if (object['url'] === "/" && active === "/dashboard") {
            isActive = true;
        }

        return (
            <li key={`${object['name']}${_key}`} className="nav-item" style={{margin: '1px 8px'}}>
                <Link to={object['url']} className={isActive ? `nav-link active` : `nav-link`} style={{
                    borderRadius: '8px',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    transition: 'all 150ms ease',
                    borderLeft: 'none',
                    fontSize: '13px',
                    fontWeight: isActive ? '600' : '500',
                    color: isActive ? '#047857' : '#475569',
                    background: isActive ? '#ECFDF5' : 'transparent'
                }}>
                    {itemIcon}
                    {ItemText}
                </Link>
            </li>

        );
    }

    /**
     * Render function for singular dictionary
     *
     * @param {any} dictionary      dictionary containing group of child :: Side Menu item (single)
     */
    __render_single(dictionary, whoIsOpen, whoIsActive) {
        /*
        ** contain only single child
        ** special key :: this.state.render_key decided either to render or not
        */

        if (dictionary[this.state.render_key]) {
            delete dictionary[this.state.render_key];
            delete dictionary[this.state.fa_icon];

            var __html = [];

            for (var key in dictionary) {
                __html.push(this.__render(dictionary[key], key, whoIsOpen, whoIsActive))
            }

            return __html;
        }

        return;
    }

    /**
     *
     * render for rendering sub Side Menu items
     *
     * @param {any} dictionary       containing group :: multiple items
     * @param {any} Name             Name of the group
     */
    __render_group(dictionary, Name, whoIsOpen, whoIsActive) {

        var menuKey = Name;
        var isOpen = this.state.openMenus[menuKey] || false;
        let openClass = isOpen ? 'nav-item-open nav-item-expanded' : '';
        let activeClass = Name === whoIsOpen ? 'active' : '';

        // contains multiples childs
        var textCapitalize = true;
        var displayName = Name;

        if (displayName === "users") {
            displayName = "Employees";
            textCapitalize = false;
        }
        else if (displayName === "ai-reports") {
            displayName = "AI Reports";
            textCapitalize = false;
        }
        else {
            displayName = displayName.replace('-', ' ');
            textCapitalize = true;
        }

        if (dictionary[this.state.render_key]) {
            var FI = dictionary[this.state.fa_icon];

            delete dictionary[this.state.render_key];
            delete dictionary[this.state.fa_icon];

            var _keys = Object.keys(dictionary);
            let isGroup = true;
            var self = this;
            var __html = <li key={displayName} className={`nav-item nav-item-submenu ${openClass}`} style={{margin: '1px 8px'}}>
                <a href="#" className={`nav-link ${activeClass}`} onClick={function(e) { e.preventDefault(); self.toggleMenu(menuKey); }} style={{
                    borderRadius: '8px',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    transition: 'all 150ms ease',
                    borderLeft: 'none',
                    fontSize: '13px',
                    fontWeight: '500'
                }}>
                    <div style={{ width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className={`${FI} side-menu_icon`} aria-hidden="true"> </i></div>
                    <span className={textCapitalize ? "text-capitalize ml-2" : "ml-2"} style={{fontSize: '13px'}}> {displayName} </span>
                </a>
                <ul className="nav nav-group-sub text-capitalize" data-submenu-title={displayName} style={{display: isOpen ? 'block' : 'none', padding: '2px 0'}}>
                    {
                        _keys.map((key, counter) => {
                            return this.__render(dictionary[key], key, whoIsOpen, whoIsActive, isGroup)
                        })
                    }
                </ul>
            </li>


            return __html;
        }

        return;
    }

    /**
     *
     * Rendering dictionary depending upon the grouping or single item
     *
     * @param {any} final_dictionary    final dictionary containing the final Side Menu in a defined structure
     */
    __render_dictionary(final_dictionary, whoIsOpen, whoIsActive) {
        var __html = []

        var _keys = Object.keys(final_dictionary);
        for (var i = 0; i < _keys.length; i++) {
            var sub_keys = Object.keys(final_dictionary[_keys[i]]);
            if (sub_keys.length > 3) {
                __html.push(this.__render_group(final_dictionary[_keys[i]], _keys[i].split('/')[1], whoIsOpen, whoIsActive));
            }
            else {
                __html.push(this.__render_single(final_dictionary[_keys[i]], whoIsOpen, whoIsActive));
            }
        }

        return __html
    }

    /**
     *  Display the navigator when mobile view is activated
     */
    __render_mobile_navigator() {
        return (
            <div className="sidebar-mobile-toggler text-center" style={{
                borderBottom: '1px solid #E2E8F0',
                padding: '12px 16px',
                background: '#fff'
            }}>
                <a href="#" className="sidebar-mobile-main-toggle" style={{color: '#475569'}}>
                    <i className="icon-arrow-left8"></i>
                </a>
                <span style={{fontSize: '13px', fontWeight: '600', color: '#0F172A'}}>Navigation</span>
                <a href="#" className="sidebar-mobile-expand" style={{color: '#475569'}}>
                    <i className="icon-screen-full"></i>
                    <i className="icon-screen-normal"></i>
                </a>
            </div>
        );
    }

    /**
     *  Rendering the User card and their corresponding actions on side menu
     */
    __render_user_card() {
        const { User } = this.state
        let splitEmail = User['accountEmail'].split('@')
        const name = splitEmail
        return (
            <div className="sidebar-user" style={{borderBottom: '1px solid #F1F5F9'}}>
                <div className="card-body" style={{padding: '16px 20px'}}>
                    <div className="media" style={{alignItems: 'center'}}>
                        <a href="#" style={{textDecoration: 'none'}}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '12px',
                                background: 'linear-gradient(135deg, #10B981 0%, #14B8A6 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(16, 185, 129, 0.2)'
                            }}>
                                <span style={{color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase'}}>
                                    {name[0].charAt(0)}
                                </span>
                            </div>
                        </a>

                        <div className="media-body ml-3">
                            <div style={{fontWeight: '600', fontSize: '13px', color: '#0F172A', textTransform: 'capitalize'}}>{name[0].toLowerCase()}</div>
                            <div style={{fontSize: '11px', color: '#94A3B8', marginTop: '1px'}}>
                                {name[1]}
                            </div>
                        </div>

                        <div className="ml-3 align-self-center">
                            <button type="button" className="btn btn-outline-light-100 border-transparent btn-icon btn-sm sidebar-control sidebar-main-resize d-none d-lg-inline-flex" style={{
                                border: 'none',
                                background: 'transparent',
                                padding: '4px',
                                borderRadius: '6px',
                                cursor: 'pointer'
                            }}>
                                <i className="icon-transmission" style={{color: '#94A3B8', fontSize: '14px'}}></i>
                            </button>

                            <button type="button" className="btn btn-outline-light-100 border-transparent btn-icon btn-sm sidebar-mobile-main-toggle d-lg-none" style={{
                                border: 'none',
                                background: 'transparent',
                                padding: '4px',
                                borderRadius: '6px',
                                cursor: 'pointer'
                            }}>
                                <i className="icon-cross2" style={{color: '#94A3B8', fontSize: '14px'}}></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     *  Main render Function
     * --------------------------------------------------------------------------------
     *
     * Then rearranging the user permission according to the standard template
     *
     * Then Render the dictionary build in the previous step
     */
    render() {
        var final_dictionary = this.__build_render_dictionary();
        var __html = <div></div>
        var activation = this.checkCurrentURL();

        var whoIsActive = activation['whoIsActive'];
        var whoIsOpen = activation['whoIsOpen'];

        if (!_.isEmpty(final_dictionary))
            __html = this.__render_dictionary(final_dictionary, whoIsOpen, whoIsActive)

        return (
            <div className="sidebar sidebar-light sidebar-main sidebar-fixed sidebar-expand-md noprint" id="sideBar" style={{
                background: '#fff',
                borderRight: '1px solid #E2E8F0'
            }}>

                {this.__render_mobile_navigator()}

                <div className="sidebar-content side-menu-zIndex">

                    <div className="card card-sidebar-mobile" style={{border: 'none', boxShadow: 'none', background: 'transparent', margin: 0}}>
                        <ul className="nav nav-sidebar" data-nav-type="accordion" style={{padding: '4px 0'}}>
                            <li className="nav-item-header" style={{padding: '20px 20px 8px'}}>
                                <div className="sidebar-heading" style={{
                                    fontSize: '10px',
                                    fontWeight: '700',
                                    letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    color: '#94A3B8'
                                }}>Navigation</div>
                                <i className="icon-menu" title="Navigation"></i>
                            </li>

                            {__html}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ activeUser }) {
    return { activeUser }
}

export default connect(mapStateToProps)(withRouter(SideMenu));
